import { useTranslation } from "react-i18next";
import { Mail, Clock, MapPin } from "lucide-react";
import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { LeadForm } from "@/components/site/LeadForm";
import { useLang } from "@/lib/lang";

export default function Contact() {
  const { t } = useTranslation();
  const lang = useLang();

  const info = [
    { icon: Mail, label: t("footer.contact_email"), href: `mailto:${t("footer.contact_email")}`, testId: "contact-email-link" },
    { icon: Clock, label: t("contact.info_response") },
    { icon: MapPin, label: t("contact.info_based") },
  ];

  return (
    <>
      <Seo title={t("contact.seo_title")} description={t("contact.seo_desc")} lang={lang} />
      <PageHero overline={t("contact.overline")} title={t("contact.title")} sub={t("contact.sub")} />

      <section className="px-6 pb-28 lg:px-10" data-testid="contact-section">
        <div className="mx-auto grid max-w-7xl gap-14 lg:grid-cols-[0.8fr_1.2fr]">
          <Reveal>
            <h2 className="font-display text-2xl font-semibold text-ostelo-deep">{t("contact.info_title")}</h2>
            <div className="mt-8 space-y-6">
              {info.map((i) => (
                <div key={i.label} className="flex items-center gap-4">
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-ostelo-sky">
                    <i.icon size={18} className="text-ostelo-blue" />
                  </div>
                  {i.href ? (
                    <a href={i.href} data-testid={i.testId} className="text-sm font-semibold text-ostelo-deep transition-colors duration-300 hover:text-ostelo-blue">
                      {i.label}
                    </a>
                  ) : (
                    <p className="text-sm text-ostelo-ink/70">{i.label}</p>
                  )}
                </div>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <LeadForm kind="contact" />
          </Reveal>
        </div>
      </section>
    </>
  );
}
